import { ModalReportEdit } from './modal-report-edit';
import { ModalReportView } from './modal-report-view';

const ModalReport = ({ disabled, ...props }) => {
    if (disabled) {
        return (
            <ModalReportView {...props} />
        );
    }

    return (
        <ModalReportEdit {...props} />
    );
}

export { ModalReport };
